export { default } from './CarrierInformation';
export type { CarrierInformationProps } from './CarrierInformation';
